import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  const projectId = typeof window !== "undefined" ? localStorage.getItem("bg_pending_project") : null;
  return (
    <div className="min-h-screen bg-[#FBFAF9] flex items-center justify-center px-6">
      <div className="card-premium rounded-2xl p-10 max-w-md w-full text-center" data-testid="payment-cancel">
        <div className="h-14 w-14 rounded-2xl bg-slate-100 flex items-center justify-center mx-auto mb-5">
          <XCircle className="h-8 w-8 text-slate-500" strokeWidth={1.75} />
        </div>
        <h1 className="font-display text-2xl font-bold text-slate-900">Payment cancelled</h1>
        <p className="mt-2 text-slate-500">No charge was made. You can book your consultation again anytime.</p>
        <Button data-testid="cancel-continue" onClick={() => navigate(projectId ? `/project/${projectId}` : "/dashboard")}
          className="mt-6 bg-[#0E9AC8] hover:bg-[#0B7EA4] text-white rounded-xl transition-colors">Back to project</Button>
      </div>
    </div>
  );
}
